import React, { useState } from 'react';
import '../styles/ShareIcon.scss';

interface ShareIconProps {
    shareUrl: string;
    title: string;
}

const ShareIcon: React.FC<ShareIconProps> = ({ shareUrl, title }) => {
    const [showModal, setShowModal] = useState(false);
    const [copyFeedback, setCopyFeedback] = useState<string>("");

    const toggleModal = () => {
        setShowModal(prev => !prev);
    };

    const handleCopyLink = async () => {
        try {
            await navigator.clipboard.writeText(shareUrl);
            setCopyFeedback("Link copiado!");
            setTimeout(() => setCopyFeedback(""), 2000);
        } catch (err) {
            setCopyFeedback("Erro ao copiar");
            setTimeout(() => setCopyFeedback(""), 2000);
        }
    };

    // Fecha o modal quando o usuário clica fora da caixa de diálogo
    const handleOverlayClick = () => {
        setShowModal(false);
    };

    // Impede que o clique dentro da modal feche o modal
    const stopPropagation = (e: React.MouseEvent) => e.stopPropagation();

    // Constroi o caminho do ícone de compartilhamento com base no PUBLIC_URL configurado
    const shareIconPath = process.env.PUBLIC_URL + '/assets/share.webp';

    return (
        <div className="share-icon-wrapper">
            <img
                src={shareIconPath}
                alt="Compartilhar"
                className="share-icon"
                onClick={toggleModal}
            />
            {showModal && (
                <div className="modal-overlay" onClick={handleOverlayClick}>
                    <div className="modal" onClick={stopPropagation}>
                        {/* Botão de fechar com label para acessibilidade */}
                        <button className="modal-close" onClick={toggleModal} aria-label="Fechar modal">×</button>
                        <div className="modal-content">
                            <div className="modal-url">
                                <input type="text" readOnly value={shareUrl} />
                                <button onClick={handleCopyLink}>Copiar Link</button>
                                {copyFeedback && <span className="copy-feedback">{copyFeedback}</span>}
                            </div>
                            <div className="modal-share-icons">
                                <a
                                    href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Facebook
                                </a>
                                <a
                                    href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(shareUrl)}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Twitter
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ShareIcon;
